<template lang="pug">
	#mobile-conversion-bar(v-if="this.isMobile && !closed" :class="{'shown': loaded}")
		sfc-dfp-ad(ad-unit="savingforcollege_other_mobile_adhesion" sizes="[[320, 50]]" :responsive="true")
		.close-x-icon-container(@click="closed = true")
			sfc-x-icon.close-x-icon

</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'
#mobile-conversion-bar
	max-width: 320px
	position: fixed
	bottom: -200px
	left: calc(50% - 160px)
	transition(bottom, 1000ms, ease)
	z-index: 1000
	&.shown
		bottom: 0
	.close-x-icon-container
		position: absolute
		top: 0
		right: 0
		display: flex
		top: -20px
		background: #fff
		padding: 2px
		border-radius(5px 5px 0 0)
		border: 1px solid #657486
		z-index: -1
		.close-x-icon
			border-radius: 50%
			padding: 2px
			opacity: 0.75
			>>> path
				fill: #000
</style>

<script>
import SfcXIcon from '@/common/components/icons/x-icon'
export default {
	components: {
		SfcXIcon
	},
	data () {
		return {
			iframeAttempts: 0,
			isMobile: false,
			closed: false,
			loaded: false
		}
	},
	mounted(){
		window.addEventListener('resize', this.handleResize)
		this.handleResize()
	},
	methods: {
		handleResize () {
			this.isMobile = (window.innerWidth <= 575)
			if (this.isMobile && !this.closed) {
				this.checkAd()
			}
		},
		checkAd () {
			if (process.browser){
				const element = document.getElementById("mobile-conversion-bar")
				if(element){
					const iframe = element.getElementsByTagName("iframe")[0]
					if (iframe) {
						setTimeout( () => {
							this.loaded = true
						}, 1500)
						return
					}
				}

				if (this.iframeAttempts >= 100){
					return
				}

				this.iframeAttempts++
				setTimeout( () => {
					this.checkAd()
				}, 200)

			}
		}
	}
}
</script>
